import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {Angulartics2Module} from 'angulartics2';

@NgModule({
    imports: [
        CommonModule,
        Angulartics2Module
    ],
    exports: [
        Angulartics2Module
    ],
})
export class AnalyticsModule {
}
